import { Component, OnInit } from '@angular/core';
import { TotemService } from '../totem.service';
import { StorageService } from '../storage.service';

import { Categoria } from '../tiendas/categoria';
import { Tienda } from '../tiendas/tienda';
import { TipoAccesos } from '../tiendas/accesos';
import { EventEmitterService } from '../event-emitter.service';




@Component({
  selector: 'app-donde-estoy',
  templateUrl: './donde-estoy.component.html',
  styleUrls: ['./donde-estoy.component.css']
})
export class DondeEstoyComponent implements OnInit {

  tiendas = [];
  subcategorias = [];
  tiendasSinfiltro = [];
  tiendasCargadas = false;

  textoBusqueda: string;
  seleccionBuscador = 'tiendas';

  autoCompletador = false;


  KEY = 'dondeVoy';
  constructor(private totemService: TotemService, private localStorage: StorageService,
              private eventEmitterService: EventEmitterService) { }

  ngOnInit() {
    this.obtenerEstacionamiento();
    this.obtenerServicios();
    this.obtenerTiendas();
  }
  ManageFooter(manage: any) {
    this.eventEmitterService.activarFooter(manage);
  }

  obtenerEstacionamiento() {
    const datoLocal = this.localStorage.getNodosRuta();
    if (datoLocal.tipoInicio === 'estacionamiento') {
      const estacionamientoNombre = this.totemService.getEstacionamientoPorID(parseInt(datoLocal.inicio));
      this.textoBusqueda = `Estacionamiento ${estacionamientoNombre}`;
    }
  }

  async obtenerServicios() {
    try {
      let resultado = await this.totemService.getTipoAccesos().toPromise();
      const datoInicio = this.localStorage.getNodosRuta();
      resultado = resultado.map( tipoAcceso => {
        if (datoInicio.tipoInicio === 'servicios' && tipoAcceso.id === parseInt(datoInicio, 10))
          this.textoBusqueda = tipoAcceso.nombre;
        return new TipoAccesos(tipoAcceso);
      });
      console.log('[SERVICIOS]', resultado);
    } catch (err) {
      console.error(err);
    }
  }

  async obtenerTiendas() {
    try {
      // obtener tiendas
      let resultado = await this.totemService.obtenerTiendasOrdenadas('es');
      const datoInicio = this.localStorage.getNodosRuta();
      resultado = resultado.map(tienda => {
        tienda.nombrePiso = tienda.nombre + ' - Piso ' + tienda.numeroPiso;
        if (datoInicio.tipoInicio === 'tiendas' && tienda.puntoInteres === parseInt(datoInicio.inicio, 10))
          this.textoBusqueda = tienda.nombrePiso;
        return tienda;
      });
      // obtener categorias
      this.subcategorias = await this.totemService.obtenerCategoriasPorTiendas('es',resultado);

      this.tiendas = this.totemService.sortByKey(resultado);
      this.tiendasSinfiltro = this.tiendas.slice();
      this.tiendasCargadas = true;
      console.log('[TIENDAS]', this.tiendas);
      console.log('[CATEGORIAS]', this.subcategorias);
    } catch (err) {
      console.error(err);
    }
  }

  busqueda(event: any) {
    this.textoBusqueda = (event.target as HTMLInputElement).value;
    console.log('[BUSQUEDA]', this.textoBusqueda);

    this.tiendas = !this.textoBusqueda || this.textoBusqueda === '' ?
                       this.tiendasSinfiltro : this.tiendas;
    this.filtrarTiendas(this.textoBusqueda);
  }

  filtrarTiendas(input: any) {
    input = input.toUpperCase();
    // filtrar que comienzan con la busqueda
    const comienzan = this.tiendasSinfiltro.filter( tienda => {
      const nombreTienda = this.totemService.eliminarDiacriticos(tienda.nombrePiso);
      return nombreTienda.toUpperCase().indexOf(input) === 0;
    });
    // console.log('[COMIENZAN]', comienzan);
    const tiendasFiltradas = this.eliminarFiltrados(this.tiendasSinfiltro, comienzan);
    // filtrar que contienen con la busqueda
    const contienen = tiendasFiltradas.filter(tienda => {
      const nombreTienda = this.totemService.eliminarDiacriticos(tienda.nombrePiso);
      return nombreTienda.toUpperCase().includes(input);
    });
    // console.log('[CONTIENEN]', contienen);
    // const tiendasFiltradas2 = this.eliminarFiltrados(tiendasFiltradas, comienzan);
    // // filtrar tiendas con tags
    // let conTags = [];
    // if (input.length > 1) {
    //   conTags = tiendasFiltradas2.filter((tienda: Tienda) => {s
    //     const tiendasConTags = tienda.tags.filter((tagstiendas) => {
    //       const tag = this.totemService.eliminarDiacriticos(tagstiendas);
    //       return tag.toUpperCase().includes(input);
    //     });
    //     if (tiendasConTags.length !== 0) {
    //       const sindiDactricos = [];
    //       for (const tagsin of tiendasConTags) {
    //         sindiDactricos.push(this.totemService.eliminarDiacriticos(tagsin));
    //       }
    //       tienda.tags = sindiDactricos;
    //       return tienda;
    //     }
    //   });
    // }
    // console.log('[conTags]', conTags);
    const arregloTiendas = comienzan.concat(contienen);
    this.tiendas = arregloTiendas;
    console.log('TIENDAS FILTRADAS', this.tiendas);
  }

  eliminarFiltrados(tiendasporfiltrar: any, tiendasfiltradas: any) {
    const nuevalista = tiendasporfiltrar.filter( tienda => {
      return tiendasfiltradas.indexOf(tienda) === -1;
    });
    return nuevalista;
  }

  toggleDropDown() {
    setTimeout(() => {
      this.autoCompletador = !this.autoCompletador;
    }, 150)
  }

  seleccionar(tienda) {
    this.textoBusqueda = tienda.nombrePiso;
    this.localStorage.setInicio(tienda.puntoInteres.toString(), 'tiendas', '');
  }

  bli() {
    this.localStorage.setInicio('bli', '1', '2');
  }
}
